import React from 'react';

const Hero = () => {
  return (
    <section className="relative min-h-screen w-full flex items-center overflow-x-hidden pt-20">
      {/* Bleeding Background Image */}
      <div className="absolute top-0 right-[-10%] bottom-0 w-[80%] z-0 skew-x-[-4deg] overflow-hidden">
        <img 
          src="https://images.unsplash.com/photo-1530143311094-34d807799e8f?q=80&w=2069&auto=format&fit=crop" 
          alt="Athletic performance" 
          className="w-full h-full object-cover grayscale contrast-125 opacity-30 transform scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-transparent via-background/60 to-background"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full py-20">
        <div className="max-w-5xl">
          <div className="mb-6 flex items-center gap-4 animate-pulse">
            <div className="h-[2px] w-12 bg-success"></div>
            <span className="font-lexend font-bold text-success text-xs tracking-[0.4em] uppercase">HIGH PERFORMANCE ONLY</span>
          </div>
          
          <h1 className="font-lexend font-extrabold text-[clamp(2.5rem,12vw,8.5rem)] leading-[0.85] text-white mb-10 tracking-tighter uppercase italic transform -skew-x-12 origin-left">
            LLEVA A TU <br />
            <span className="text-pacer-start">EQUIPO</span> AL <br />
            <span className="relative">
              SIGUIENTE
              <span className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-success to-pacer-start"></span>
            </span> <br />
            <span className="text-transparent bg-clip-text bg-pacer-gradient">NIVEL</span>
          </h1>

          <div className="flex flex-col md:flex-row items-start md:items-end gap-12 mt-16">
            <div className="space-y-8">
              <p className="font-inter text-[#666] text-sm tracking-wider max-w-sm uppercase leading-loose border-l border-pacer-start pl-6">
                Run Together, Progress Better. La plataforma definitiva para el comando y control de atletas de alto rendimiento.
              </p>
              
              <button className="bg-pacer-gradient text-background font-lexend font-extrabold px-14 py-6 rounded-sm text-lg tracking-[0.2em] hover:shadow-[0_0_50px_rgba(114,220,255,0.4)] transition-all transform hover:scale-105 active:scale-95 group relative overflow-hidden">
                <span className="relative z-10">CONECTAR CON STRAVA</span>
                <div className="absolute inset-0 bg-white/20 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-500 skew-x-[-20deg]"></div>
              </button>
            </div>

            {/* Asymmetric data badge */}
            <div className="hidden lg:block bg-card p-6 rotate-3 border-l-4 border-success">
              <div className="text-[10px] font-lexend font-bold text-[#888] tracking-widest mb-1 uppercase">Live Performance Index</div>
              <div className="text-4xl font-lexend font-extrabold text-white italic tracking-tighter">98.4<span className="text-sm text-success ml-1">VRC</span></div>
            </div>
          </div>
        </div>
      </div>

      {/* Speed lines decorative element */}
      <div className="absolute bottom-20 right-0 w-1/3 h-[1px] bg-gradient-to-l from-pacer-start to-transparent opacity-30"></div>
      <div className="absolute bottom-24 right-10 w-1/4 h-[1px] bg-gradient-to-l from-success to-transparent opacity-20"></div>
    </section>
  );
};

export default Hero;
